/**
 * Central date formatting for the NORA UI.
 *
 * Rule (per user request): show only a human date like "15. Juli 2026" – never a time.
 * Internally values can still be full ISO timestamps; we just strip the time on display.
 */

const LONG_DATE_OPTIONS = { day: "numeric", month: "long", year: "numeric" };

export function formatDeDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString("de-DE", LONG_DATE_OPTIONS);
}

/**
 * Convert an <input type="date"> value ("YYYY-MM-DD") into an ISO datetime string.
 * We anchor at 12:00 local noon to avoid off-by-one-day drift across timezones.
 * If the value already contains a time (e.g. legacy datetime-local strings), it is used as-is.
 */
export function dateInputToISO(value) {
  if (!value) return null;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return new Date(`${value}T12:00:00`).toISOString();
  }
  return new Date(value).toISOString();
}

/**
 * Convert an ISO datetime (or date) into a "YYYY-MM-DD" string suitable for <input type="date">.
 */
export function isoToDateInput(value) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  // Use local calendar day (so the value shown matches what the user picked)
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
